import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  PropertyAmenities_Create,
  PropertyAmenities_Delete,
  PropertyAmenities_ReadAll,
  PropertyAmenities_ReadById,
  PropertyAmenities_ReadByMasterId,
  PropertyAmenities_Update
} from "src/app/GlobalVariable";
import {
  PropertyAmenitiesCreateRequestDTO,
  PropertyAmenitiesDeleteRequestDTO,
  PropertyAmenitiesDTO,
  PropertyAmenitiesList,
  PropertyAmenitiesReadByIdRequestDTO,
  PropertyAmenitiesReadByMasterIdRequestDTO,
  PropertyAmenitiesUpdateRequestDTO
} from "./property-amenities.interface";

@Injectable({
  providedIn: 'root'
})
export class PropertyAmenitiesService {
  private http = inject(HttpClient);

  PropertyAmenities_ReadAll(): Observable<PropertyAmenitiesList> {
    return this.http.get<PropertyAmenitiesList>(PropertyAmenities_ReadAll);
  }

  PropertyAmenities_Create(data: PropertyAmenitiesCreateRequestDTO): Observable<PropertyAmenitiesDTO> {
    return this.http.post<PropertyAmenitiesDTO>(PropertyAmenities_Create, data);
  }

  PropertyAmenities_Update(data: PropertyAmenitiesUpdateRequestDTO): Observable<PropertyAmenitiesDTO> {
    return this.http.post<PropertyAmenitiesDTO>(PropertyAmenities_Update, data);
  }

  PropertyAmenities_Delete(data: PropertyAmenitiesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PropertyAmenities_Delete, data);
  }

  PropertyAmenities_ReadById(data: PropertyAmenitiesReadByIdRequestDTO): Observable<PropertyAmenitiesDTO> {
    return this.http.post<PropertyAmenitiesDTO>(PropertyAmenities_ReadById, data);
  }

  PropertyAmenities_ReadByMasterId(data: PropertyAmenitiesReadByMasterIdRequestDTO): Observable<PropertyAmenitiesList> {
    return this.http.post<PropertyAmenitiesList>(PropertyAmenities_ReadByMasterId, data);
  }
}
